import type { UserInfo } from '@ixigo-packages/login/react';
import { getBrowserAuth } from '@/lib/login/auth';

export type { UserInfo };

/**
 * The signed-in user, straight from the login SDK (`browserAuth`) — the core
 * `UserInfo` as-is, no host remapping. `getState().user` is the SDK's
 * lazily-hydrated user: `<AuthProvider>` fetches it on auth-settle (served from
 * the SDK's persisted cache, no network on a returning session), so by the time
 * analytics fire on a user action it's populated. Synchronous `getState()` keeps
 * the call sites unchanged. Consumers only read `uid` (+ presence).
 */
export function getUserInfo(): UserInfo | null {
	return getBrowserAuth().getState().user;
}
